var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('Icon',{staticClass:"mr-4",attrs:{"icon":_vm.paymentIcon,"color":"systemWalletGreen","large":""}}),_c('Typography',{attrs:{"variant":"subtitle-1"}},[_vm._v(" Add a "+_vm._s(_vm.paymentLanguage.toLowerCase())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }